import { DataFieldType } from '@/app/[locale]/admin/lib/DataFieldType';
import { DataField, FormField } from '@/components/data/dataType';
import { formFields } from './formFields';

export const getFilteredFields = (
    editingField: FormField | null,
): DataField[] => {
    return formFields.filter(field => {
        if (field.name === 'dataList' && editingField) {
            return (
                editingField.dataType === DataFieldType.SelectText ||
                editingField.dataType === DataFieldType.RadioList
            );
        }
        return true;
    });
};
